// src/components/index.js

import Vue from "vue";
import payLayer from "./payLayer.vue";

const Components = {
  payLayer
};

Object.keys(Components).forEach(name => {
    Vue.component(name, Components[name]);
});

export default Components;